/** Matches Odoo ROUNDING_MODES / handling_unit_api. */
export const HU_ROUNDING_MODES = [
  'ROUND_UP',
  'ROUND_DOWN',
  'ROUND_FLOOR',
  'ROUND_CEILING',
  'ROUND_HALF_UP',
  'ROUND_HALF_DOWN',
  'ROUND_HALF_EVEN',
  'ROUND_05UP',
] as const;

export type HuRoundingMode = (typeof HU_ROUNDING_MODES)[number];
